import React from 'react'
import { Card, CardActions, CardHeader, CardMedia, CardTitle, CardText } from 'material-ui/Card'
import FlatButton from 'material-ui/FlatButton'
import RaisedButton from 'material-ui/RaisedButton'
import './RecordCard.css'

export default class RecordCard extends React.Component {
  state = {
    isPlaying: false
  }

  playVoice = () => {
    var that = this
    this.setState({ isPlaying: true })
    wx.playVoice({
      localId: this.props.localId // 需要播放的音频的本地ID，由stopRecord接口获得
    })
    wx.onVoicePlayEnd({
      success: function (res) {
        that.setState({ isPlaying: false })
      }
    })
  }

  pauseVoice = () => {
    this.setState({ isPlaying: false })
    wx.pauseVoice({
      localId: this.props.localId // 需要播放的音频的本地ID，由stopRecord接口获得
    })
  }

  renderMusicPlayer = () => {
    const { isPlaying } = this.state
    return (
      <div style={{ margin: '21px 20px 5px 20px' }} >
        <RaisedButton onClick={isPlaying ? this.pauseVoice : this.playVoice}
          buttonStyle={{ borderRadius: 23 }}
          style={{ borderRadius: 23, width:'100%' }} >
          <div className='recordcard-player-button'>
            <img  className='recordcard-player-button'
              src={isPlaying ? require('../../../../components/svgs/pause.svg') : require('../../../../components/svgs/play.svg')} />
            <img src={require('../../../../components/svgs/play1.svg')} />
          </div>
        </RaisedButton>
      </div >
    )

  }

  renderTextInfo = (info) => (
    <CardText style={{
      color:'rgb(36, 193, 209)'
    }}>
      {info}
    </CardText>
  )

  render() {
    const { user, localId } = this.props
    const { userInfo, isRecorded } = user
    const { nickname, city, headimgurl } = userInfo
    return (
      <Card style={{
        position: 'relative',
        width: '91vw',
        height: '22vh',
        margin: '0px 16px',
        paddingBottom: 10,
        boxShadow: '0 2px 10px 0 rgba(63,94,117,0.50)',
        // animation: 'recordcardmove 1s 1'
      }} >
        <CardHeader
          title={nickname}
          subtitle={city}
          textStyle={{ paddingRight: 0, maxWidth: '85%' }}
          avatar={<img
            src={headimgurl}
            className="recordcard-head-image" />}
          style={{
            padding: '16px 16px 0px 16px',
            textAlign: 'left',
          }}
        />
        {(!!localId && !isRecorded) &&
          (<div className='recordcard-refresh-button'>
              <FlatButton label="重新录制" primary={true} onClick={() => {
                this.props.refreshLocalId()
              }} />
        </div>)}
        {isRecorded
          ? this.renderTextInfo('您已经表白过啦，快去邀请好友为您点赞 扶您“上墙”吧！')
          : (localId
              ? this.renderMusicPlayer()
              : this.renderTextInfo('按住下方按钮开始录音吧'))}
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Home/components/RecordCard/index.js